"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdGenerator = void 0;
var IdGenerator = (function () {
    function IdGenerator() {
        this.id = 0;
        this.documentRelationId = this.calcDocumentRelationId();
    }
    IdGenerator.prototype.generateImageName = function (modelImageId) {
        return 'image' + modelImageId.toString();
    };
    IdGenerator.prototype.generateImageRelationId = function (modelImageId) {
        return 'Image' + modelImageId.toString();
    };
    IdGenerator.prototype.calcDocumentRelationId = function () {
        return "R" + this.next().toString(16);
    };
    IdGenerator.prototype.calcCorePropertiesDocumentRelationId = function () {
        return 'core' + this.documentRelationId;
    };
    IdGenerator.prototype.calcCustomPropertiesDocumentRelationId = function () {
        return 'custom' + this.documentRelationId;
    };
    IdGenerator.prototype.next = function () {
        return this.id++;
    };
    return IdGenerator;
}());
exports.IdGenerator = IdGenerator;
